import PropTypes from 'prop-types'
import {useStyletron} from 'baseui'
import Icon from 'baseui/icon/icon'

const IconCheckCircle = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Circle check'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon
      viewBox="0 0 80 80"
      ref={ref}
      title={title}
      size={size}
      color={color}
      overrides={overrides}
    >
      <title>{title}</title>
      <g clipPath="url(#clip0_6125_249)">
        <path
          d="M40 6.66699C44.6111 6.66699 48.9444 7.54115 53 9.29004C57.0555 11.0411 60.583 13.417 63.583 16.417C66.583 19.417 68.9581 22.9444 70.707 27C72.4581 31.0555 73.333 35.3889 73.333 40C73.333 44.6111 72.4581 48.9445 70.707 53C68.9581 57.0556 66.583 60.583 63.583 63.583C60.583 66.583 57.0556 68.9581 53 70.707C48.9445 72.4581 44.6111 73.333 40 73.333C35.3889 73.333 31.0555 72.4581 27 70.707C22.9444 68.9581 19.417 66.583 16.417 63.583C13.417 60.583 11.0419 57.0556 9.29297 53C7.5419 48.9445 6.66699 44.6111 6.66699 40C6.66699 35.3889 7.5419 31.0555 9.29297 27C11.0419 22.9444 13.417 19.417 16.417 16.417C19.417 13.417 22.9445 11.0412 27 9.29004C31.0556 7.54115 35.3889 6.66699 40 6.66699ZM40 13.333C32.6112 13.333 26.3202 15.9299 21.127 21.123C15.9314 26.3186 13.333 32.6111 13.333 40C13.333 47.3889 15.9314 53.6814 21.127 58.877C26.3202 64.0701 32.6112 66.667 40 66.667C47.3889 66.667 53.6814 64.0703 58.877 58.877C64.0703 53.6814 66.667 47.3889 66.667 40C66.667 32.6111 64.0703 26.3186 58.877 21.123C53.6814 15.9297 47.3889 13.333 40 13.333ZM54.167 28.583C55.1113 28.5831 55.889 28.889 56.5 29.5C57.1111 30.1111 57.4311 30.8745 57.46 31.79C57.4866 32.7078 57.1941 33.4719 56.583 34.083L37.667 53C37.0559 53.6111 36.2775 53.917 35.333 53.917C34.3887 53.9169 33.611 53.611 33 53L23.5 43.5C22.889 42.889 22.5831 42.1113 22.583 41.167C22.583 40.2225 22.8889 39.4441 23.5 38.833C24.111 38.2221 24.8754 37.9037 25.793 37.877C26.7084 37.8481 27.4719 38.139 28.083 38.75L35.333 46L51.833 29.5C52.4441 28.8889 53.2225 28.583 54.167 28.583ZM82.5 0H79.167V-3.33301H82.5V0Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_6125_249">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}

IconCheckCircle.propTypes = {
  color: PropTypes.string,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
  overrides: PropTypes.object,
}

export default IconCheckCircle